import { styled } from '@mui/material/styles'
import { Box, Button, Checkbox, Typography, darken } from '@mui/material'

export const Trigger = styled(Button)`
  min-width: 172px;
  height: 40px;
  padding: 0 16px;
  justify-content: space-between;
  border-radius: 6px;
  text-transform: none;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.blue1};
  background-color: ${({ theme }) => theme.palette.custom.gray4};

  &:hover {
    background-color: ${({ theme }) =>
      darken(theme.palette.custom.gray4, 0.025)};
  }
`

export const ChevronWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 150ms ease;

  &.open {
    transform: rotate(180deg);
  }
`

export const TabsRow = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray9};
`

export const TabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  padding: '6px 16px',
  borderRadius: 16,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.2,
  textTransform: 'none',
  color: active ? theme.palette.custom.white : theme.palette.custom.blue1,
  backgroundColor: active ? theme.palette.primary.main : 'transparent',
  '&:hover': {
    backgroundColor: active
      ? theme.palette.primary.main
      : theme.palette.custom.gray4,
  },
}))

export const OptionsGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 8px;
  row-gap: 4px;
  padding: 16px;
  max-height: 360px;
  overflow-y: auto;
`

export const OptionRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'checked',
})<{ checked?: boolean }>(({ theme, checked }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  padding: '4px 8px',
  borderRadius: 8,
  cursor: 'pointer',
  backgroundColor: checked ? theme.palette.custom.gray4 : 'transparent',
  '&:hover': {
    backgroundColor: theme.palette.custom.gray4,
  },
}))

export const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  color: ${({ theme }) => theme.palette.custom.blue2};

  &.Mui-checked {
    color: ${({ theme }) => theme.palette.custom.blue2};
  }
`

export const OptionLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'checked',
})<{ checked?: boolean }>(({ theme, checked }) => ({
  fontSize: 14,
  color: checked ? theme.palette.primary.main : theme.palette.custom.blue1,
}))

export const Footer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid ${({ theme }) => theme.palette.custom.gray9};
  background-color: ${({ theme }) => theme.palette.custom.gray4};
`

export const SelectedText = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.custom.gray14};
`

export const FooterActions = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

export const ClearButton = styled(Button)`
  padding: 0 24px;
  text-transform: none;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.blue1};
  background-color: ${({ theme }) => theme.palette.custom.white};
  border: 1px solid ${({ theme }) => theme.palette.custom.gray9};

  &:hover {
    background-color: ${({ theme }) => theme.palette.custom.gray4};
  }
`

export const ApplyButton = styled(Button)`
  padding: 0 24px;
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
`
